import { Component, EventEmitter, Input, Output } from "@angular/core";
import CustomStore from "devextreme/data/custom_store";
import DataSource from "devextreme/data/data_source";
import dxTagBox from "devextreme/ui/tag_box";
import { first, trim, upperCase } from "lodash-es";
import { map } from "rxjs/operators";
import { TagBackend } from "src/app/backend/api/tag/tag.backend";
import { Category } from "src/app/backend/models/tag/tag";

@Component({
  selector: "snoots-page-detail-header-tag-box",
  template: "",
  standalone: false
})
export class PageDetailHeaderTagBoxComponent {
  @Input() tags!: string[];
  @Input() category!: Category;

  @Output()
  update: EventEmitter<string[]> = new EventEmitter<string[]>();

  dataSource: DataSource;

  constructor(private tagBackend: TagBackend) {
    this.dataSource = new DataSource({
      store: new CustomStore({
        byKey: async (key: string) => {
          return key;
        },
        load: async ({ searchValue }) => {
          return tagBackend
            .loadByName(searchValue || "")
            .pipe(map((list) => list))
            .toPromise();
        },
        insert: async (data: string) => {
          return data;
        }
      })
    });
  }

  async onTagBoxCustomItemCreating(dxEvent: {
    component: dxTagBox;
    text: string;
    customItem: any;
  }): Promise<void> {
    if (!trim(dxEvent.text)) {
      return;
    }

    dxEvent.customItem = upperCase(dxEvent.text);

    await this.tagBackend
      .create({ name: dxEvent.text, category: this.category })
      .toPromise();
  }
}
